export default __webpack_public_path__ + "static/media/cabin.62309a6a.jpg";